import { RootState } from 'app/store/rootReducer';

export const getPromotionalCode = (state: RootState) => state.promotionalCode;
export const getTemporaryPromotionForOperator = (state: RootState) =>
  state.promotionalCode.temporaryPromotionForOperator;
